export const tokenName = 'token';
export const tokenParsedName = 'tokenParsed';
export const idTokenName = 'idToken';
export const idTokenParsedName = 'idTokenParsed';
export const refreshTokenName = 'refreshToken';
export const refreshTokenParsedName = 'refreshTokenParsed';
